import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private readonly router: Router,
        @Inject(OKTA_AUTH) private readonly oktaAuth: OktaAuth
    ) {}

    async canActivate(): Promise<boolean> {
        const isAuthenticated = await this.oktaAuth.isAuthenticated();
        if (isAuthenticated) {
            return true;
        }
        await this.router.navigate(['/login']);
        return false;
    }
}
